/* Package imports */
import axiosInstance from '../axiosInstance';
import { authActions } from '../store/auth/auth';
import { showErrorToast } from './toast';

/**
 * Setup axios interceptors for auto-logout on token expiration
 * @param {object} store - Redux store instance
 */
export const setupAxiosInterceptors = (store) => {
    // Request interceptor - Add auth token to requests
    axiosInstance.interceptors.request.use(
        (config) => {
            const state = store.getState();
            const token = state.auth.token;
            
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }
            
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    // Response interceptor - Handle auto-logout on token expiration
    axiosInstance.interceptors.response.use(
        (response) => {
            return response;
        },
        async (error) => {
            // Handle 401 Unauthorized errors (token expired or invalid)
            if (error.response?.status === 401) {
                const state = store.getState();
                const isLoggedIn = state.auth.token !== null;
                
                // Only logout if user is actually logged in
                if (isLoggedIn) {
                    // Logout user
                    store.dispatch(authActions.logout());
                    
                    // Show error toast
                    showErrorToast('Your session has expired. Please login again.');
                    
                    // Redirect to login page if not already there
                    if (window.location.pathname !== '/account/login') {
                        // Small delay to ensure toast is visible
                        setTimeout(() => {
                            window.location.href = '/account/login';
                        }, 500);
                    }
                }
            }

            return Promise.reject(error);
        }
    );
};
